<template>
    <figure :class="[
        'z-figure',
        { 'z-figure--video': this.video }
    ]">
        <div class="z-figure__container">
            <z-image
                v-if="image"
                class="z-figure__image"
                background
                :src="image"
            />
            <slot name="video" />
            <figcaption
                class="z-figure__caption"
                v-if="caption"
            >
                <span v-html="caption"></span>
            </figcaption>
        </div>
    </figure>
</template>

<script>
export default {
    name: 'z-figure',
    props: {
        image: {
            type: String
        },
        caption: {
            type: String
        },
        video: Boolean
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
